import React from 'react';
import { IconTooltip } from './IconTooltip';

export const OddsBoostTooltip = () => (
  <IconTooltip iconName="arrow-up" label="Boosted Odds" />
);
